import React, { useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

import { connect } from "react-redux";
import { v4 as uuid } from "uuid";
import { requestResetPassword } from "../../redux-store/action/auth";

const RequestPasswordReset = ({ requestResetPassword }) => {
    const [formData, setFormData] = useState({ email: "" });

    const [alert, setAlert] = useState(alertObj);
    const [disabled, setDisabled] = useState(false);

    const { email } = formData;
    const { key, variant, message, active } = alert;
    const handleResetPassword = async() => {
        setDisabled(true);
        const response = await requestResetPassword(formData);
        if (response) {
            setAlert({
                key: uuid(),
                variant: "success",
                message: response.data.alert,
                active: true
            });
        }
        else {
            setAlert({
                key: uuid(),
                variant: "danger",
                message: "Failed to reset password - please contact your system administrator",
                active: true
            });
            setDisabled(false);
        }
        handleAfterRequest(response);
    };

    const handleAfterRequest = response => {
        setTimeout(() => {
            if (response.data.redirect_url) {
                window.location.replace(response.data.redirect_url);
            }
            setAlert(alertObj);
        }, 1500);
    };
    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    {active && (
                        <Alert key={key} variant={variant}>
                            {message}
                        </Alert>
                    )}
                    <Card>
                        <Card.Header>Reset Password Reset</Card.Header>
                        <Card.Body>
                            <FormGroup>
                                <FormLabel htmlFor={"email"}>
                                    E-Mail Address
                                </FormLabel>
                                <FormControl
                                    type="email"
                                    name="email"
                                    value={email}
                                    required
                                    autoComplete="email"
                                    autoFocus
                                    onChange={event =>
                                        setFormData({
                                            ...formData,
                                            email: event.target.value
                                        })
                                    }
                                />
                            </FormGroup>
                            <Button
                                variant={"primary"}
                                onClick={handleResetPassword}
                                disabled={disabled}
                            >
                                Send Password Reset Link
                            </Button>
                        </Card.Body>
                    </Card>
                    <p className="mt-2"><a href="/">Back to login</a></p>
                </Col>
            </Row>
        </Container>
    );
};

const alertObj = {
    key: "",
    message: "",
    variant: "",
    active: false
};

export default connect(null, { requestResetPassword })(RequestPasswordReset);